// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@flip/App/Store/Selectors/SettingsSelectors";
import { mergeWithCss, parseBoolean } from "@flip/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { CartLineModel, ProductAutocompleteItemModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { LazyImage } from "@insite/mobius/index";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    isPreviouslyPurchased: string;
    extendedStyles?: LazyImageProps;
}

const productPreviousPurchaseStyles: LazyImageProps = {
    width: "83px",
    css: css`
        height: auto;
        overflow: visible;
    `,
};

const ProductPreviousPurchase: FC<OwnProps> = ({ isPreviouslyPurchased, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(productPreviousPurchaseStyles, extendedStyles));
    const { previouslyPurchasedImage } = useAppSelector(state => {
        const customSettings = getSettingsCollection(state).customSettings;
        return {
            previouslyPurchasedImage: customSettings.previouslyPurchasedImage,
        };
    });

    if (!parseBoolean(isPreviouslyPurchased) || !previouslyPurchasedImage) {
        return null;
    }

    return <LazyImage src={previouslyPurchasedImage} {...styles} aria-label="Product Previous Purchased" altText="Product Previous Purchased Badge" />;
};

export default ProductPreviousPurchase;
